import { Helmet, HelmetData } from "react-helmet-async";
// import { CCPA_Img, GDPR_Img, HIPPA_Img, ISO_2, ISO_Img } from "../../../assets";
import { CCPA_Img, GDPR_Img, HIPPA_Img, ISO_2, ISO_Img } from "../../images";
import { NewFooter } from "../newFooter";
const helmetData = new HelmetData({});

export default function LegalInfo() {
  return (
    <>
      <Helmet helmetData={helmetData}>
        <title>Security &amp; Privacy Policy | Analytics Intelligence Africa | Legal Information</title>
        <link rel="canonical" href="https://africa.analyticsintelligence.com/legal-info" />
        <meta
          name="description"
          content="Read the official Security and Privacy Policy of Analytics Intelligence Africa. Learn how we collect, use, and protect personal information while complying with GDPR, CCPA, ISO 27001, and global data privacy regulations."
        />
        <meta
          name="keywords"
          content="Analytics Intelligence Africa privacy policy, Analytics Intelligence Africa security policy, legal information Africa, data protection Africa, GDPR compliance Africa, CCPA Africa, ISO 27001 Africa, cybersecurity Africa, data privacy regulations Africa, AI data protection Africa, legal disclaimer Analytics Intelligence Africa"
        />
        <meta property="og:title" content="Security & Privacy Policy | Analytics Intelligence Africa" />
        <meta property="og:description" content="Official Security and Privacy Policy of Analytics Intelligence Africa — data protection, GDPR, CCPA, and ISO compliance." />
        <meta property="og:url" content="https://africa.analyticsintelligence.com/legal-info" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://africa.analyticsintelligence.com/favicon.png" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Security & Privacy Policy | Analytics Intelligence Africa" />
        <meta name="twitter:description" content="Official Security and Privacy Policy of Analytics Intelligence Africa — data protection, GDPR, CCPA, and ISO compliance." />
        <meta name="twitter:image" content="https://africa.analyticsintelligence.com/favicon.png" />
      </Helmet>

      <main>
        <section className="min-h-[120vh] flex items-center bg-[#0E2F5D]">
          <div className="container w-full h-full flex">
            {/* Sidebar */}
            <aside className="hidden md:block w-1/4 py-4 sticky top-52 h-screen text-white">
              <ul className="space-y-5">
                <li>
                  <a
                    href="#introduction"
                    className="hover:underline font-semibold text-white"
                  >
                    Introduction
                  </a>
                </li>
                <li>
                  <a
                    href="#information-collection"
                    className="hover:underline font-semibold text-white"
                  >
                    Information Collection and Use
                  </a>
                </li>
                <li>
                  <a
                    href="#legal-disclaimer"
                    className="hover:underline font-semibold text-white"
                  >
                    Legal Disclaimer
                  </a>
                </li>
                <li>
                  <a
                    href="#security"
                    className="hover:underline font-semibold text-white"
                  >
                    Security
                  </a>
                </li>
                <li>
                  <a
                    href="#policy"
                    className="hover:underline font-semibold text-white"
                  >
                    Changes to Our Policy
                  </a>
                </li>
                <li>
                  <a
                    href="#personal-info"
                    className="hover:underline font-semibold text-white"
                  >
                    Access to Personal Information and Other Questions
                  </a>
                </li>
                <li>
                  <a
                    href="#compliance"
                    className="hover:underline font-semibold text-white active:text-[#88BEFF]"
                  >
                    Compliance with Cyber Security and Data Privacy Regulations
                  </a>
                </li>
              </ul>
            </aside>

            {/* Content */}
            <main className="w-full md:w-3/4 px-0 md:px-6 space-y-16 scroll-smooth pt-52 pb-[96px]">
              <div className="flex flex-col md:flex-row justify-between gap-3 md:gap-0 items-start">
                <h2 className="text-[28px] font-extrabold text-white">
                  Security and Privacy Policy
                </h2>

                <div className="flex-1 flex md:items-center justify-between md:justify-end md:gap-6 rounded-xl">
                  <a
                    href="https://uk.connect.amtivo.com/cert/amtivocert10002.asp?c=263404&v=m81kmdz443&e=23963"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={ISO_Img}
                      alt="compliant logo illustartion"
                      className="w-[65px]"
                    />
                  </a>
                  <a
                    href="https://uk.connect.amtivo.com/cert/amtivocert10002.asp?c=265324&v=de364nw8e9&e=23964"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={ISO_2}
                      alt="compliant logo illustartion"
                      className="w-[65px]"
                    />
                  </a>
                  <img
                    src={GDPR_Img}
                    alt="compliant logo illustartion"
                    className="w-[65px]"
                  />
                  <img
                    src={HIPPA_Img}
                    alt="compliant logo illustartion"
                    className="w-[65px]"
                  />
                  <img
                    src={CCPA_Img}
                    alt="compliant logo illustartion"
                    className="w-[65px]"
                  />
                </div>
              </div>

              <section
                id="introduction"
                className=" flex flex-col gap-2 scroll-mt-28"
              >
                <h2 className="text-2xl font-extrabold text-white">
                  Introduction
                </h2>
                <p className="text-base font-medium text-white">
                  Your privacy is important to [AI] Logic Technologies Limited
                  and [AI] Analytics Intelligence Inc, both trading globally as
                  [AI] Analytics Intelligence. This Privacy Policy (the
                  "Policy") discloses our information practices, including our
                  policies regarding the types of information that are gathered
                  and tracked through our websites, desktop, and mobile apps
                  (collectively referred to as "[AI] Analytics Intelligence
                  Sites"), descriptions of how such information is used, and
                  identification of the parties with whom the information may be
                  shared. By voluntarily using the [AI] Analytics Intelligence
                  Sites, you are indicating your consent to this Policy and
                  agreement to be bound by its terms.
                </p>
              </section>

              <section
                id="information-collection"
                className=" flex flex-col gap-8 scroll-mt-28"
              >
                <h2 className="text-2xl font-extrabold text-white">
                  Information Collection and Use
                </h2>
                <div>
                  <p className="text-base font-extrabold text-white">
                    Personal Information
                  </p>
                  <p className="text-base font-medium text-white">
                    We will need certain personally identifiable information
                    ("Personal Information") from you. You may choose to provide
                    us with Personal Information through the [AI] Analytics
                    Intelligence Sites for purposes such as registering for our
                    trainings. When you provide Personal Information to register
                    on [AI] Analytics Intelligence Sites, such Personal
                    Information will be used to provide you with access to our
                    services. We may also use the Personal Information to help
                    us understand who is using our products and services and to
                    help us manage business development activities. If you
                    inform us that you do not want us to use this Personal
                    Information as a basis for further contact with you, we will
                    respect your wishes.
                  </p>
                </div>

                <div>
                  <p className="text-base font-extrabold text-white">
                    Statistical Information
                  </p>
                  <p className="text-base font-medium text-white">
                    In addition, we sometimes collect anonymous information from
                    visits to the [AI] Analytics Intelligence Sites and services
                    such as [AI] Academy, Poweredby[AI], Data Assistant, Virtual
                    Analyst system, or mobile apps to help us provide better
                    customer service and to make the [AI] Analytics Intelligence
                    Sites as user friendly as possible. For example, we keep
                    track of the domains from which people visit, and we also
                    measure visitor activity on [AI] Analytics Intelligence
                    Sites. However, when we do so, we ensure the information
                    remains anonymous. [AI] Analytics Intelligence may use this
                    data to analyze trends and statistics and to help us provide
                    better customer service. None of the information described
                    in this paragraph is reviewed at an individual level.
                  </p>
                </div>
                <div>
                  <p className="text-base font-extrabold text-white">
                    Links to Third Party Sites
                  </p>
                  <p className="text-base font-medium text-white">
                    The [AI] Analytics Intelligence Sites may contain links to
                    other websites. [AI] Analytics Intelligence is not
                    responsible for the privacy practices or the content of such
                    websites. The links from an [AI] Analytics Intelligence Site
                    do not imply that [AI] Analytics Intelligence endorses or
                    has reviewed the third-party websites. We suggest contacting
                    the operators of those websites directly for information on
                    their privacy policies.
                  </p>
                </div>
                <div>
                  <p className="text-base font-extrabold text-white">
                    Our Disclosure of Your Personal Information and Other
                    Information:
                  </p>
                  <p className="text-base font-medium text-white">
                    [AI] Analytics Intelligence does not disclose or sell your
                    Personal Information. We consider this information to be a
                    vital part of our relationship with you. However, there are
                    certain circumstances in which we may share your Personal
                    Information with certain third parties without further
                    notice to you, as set forth below:
                  </p>

                  <ul className="space-y-2">
                    <li className="text-base font-medium text-white">
                      •{" "}
                      <span className="text-base font-bold">
                        Business Transfers:
                      </span>{" "}
                      As we develop our business, we might sell or buy
                      businesses or assets. In the event of a corporate sale,
                      merger, reorganization, dissolution, or similar event,
                      Personal Information may be part of the transferred
                      assets.
                    </li>
                    <li className="text-base font-medium text-white">
                      •{" "}
                      <span className="text-base font-bold">
                        Related Companies:
                      </span>{" "}
                      We may also share your Personal Information with our
                      subsidiaries, affiliates, and other related companies for
                      purposes consistent with this Policy.
                    </li>
                    <li className="text-base font-medium text-white">
                      •{" "}
                      <span className="text-base font-bold">
                        Agents, Consultants, and Related Third Parties:
                      </span>{" "}
                      [AI] Analytics Intelligence, like many businesses,
                      sometimes hires other companies to perform certain
                      business-related functions. Examples of such functions
                      include mailing information, maintaining databases, and
                      processing payments. When we employ another company to
                      perform a function of this nature, we only provide them
                      with the information that they need to perform their
                      specific function.
                    </li>
                  </ul>
                </div>
              </section>

              <section
                id="legal-disclaimer"
                className=" flex flex-col gap-2 scroll-mt-28"
              >
                <h2 className="text-2xl font-extrabold text-white">
                  Legal Disclaimer
                </h2>
                <p className="text-base font-medium text-white">
                  [AI] Analytics Intelligence reserves the right to disclose
                  personal information to non-affiliated third parties for
                  regulatory or reporting purposes as required by law, to
                  protect the personal safety of users of an [AI] Analytics
                  Intelligence Site or the public, to protect our rights or
                  property, and when [AI] Analytics Intelligence believes that
                  disclosure is necessary to protect our rights and/or to comply
                  with any judicial and/or other proceedings, court orders,
                  legal processes served, or pursuant to governmental,
                  intergovernmental, and/or other regulatory bodies. [AI]
                  Analytics Intelligence shall not be liable for misuse or loss
                  of personal information and/or otherwise on [AI] Analytics
                  Intelligence websites that [AI] Analytics Intelligence does
                  not have access to or control over. [AI] Analytics
                  Intelligence will not be liable for unlawful or unauthorized
                  use of your personal information due to misuse or misplacement
                  of your passwords, negligent or malicious intervention, and/or
                  otherwise.
                </p>
              </section>

              <section
                id="security"
                className=" flex flex-col gap-2 scroll-mt-28"
              >
                <h2 className="text-2xl font-extrabold text-white">Security</h2>
                <p className="text-base font-medium text-white">
                  Personal Information collected through the [AI] Analytics
                  Intelligence Sites is kept in a secure database, and all
                  reasonable precautions are taken to secure this data. However,
                  no Internet or email transmission is ever fully secure or
                  error-free. In particular, emails sent to or from an [AI]
                  Analytics Intelligence Site may not be secure. Therefore, you
                  should take special care in deciding what information you send
                  to us via email. Please keep this in mind when disclosing any
                  Personal Information to [AI] Analytics Intelligence via the
                  Internet.
                </p>
              </section>

              <section
                id="policy"
                className=" flex flex-col gap-2 scroll-mt-28"
              >
                <h2 className="text-2xl font-extrabold text-white">
                  Changes to Our Policy
                </h2>
                <p className="text-base font-medium text-white">
                  We may change our business and the [AI] Analytics Intelligence
                  Sites from time to time. As a result, it may be necessary for
                  us to make changes to this Policy. [AI] Analytics Intelligence
                  reserves the right to update or modify this Policy at any time
                  and from time to time without prior notice. Please review this
                  Policy periodically, and especially before you provide any
                  Personal Information. Your continued use of the [AI] Analytics
                  Intelligence Site after any changes or revisions to this
                  Policy shall indicate your agreement with the terms of such
                  revised Policy.
                </p>
              </section>

              <section
                id="personal-info"
                className=" flex flex-col gap-2 scroll-mt-28"
              >
                <h2 className="text-2xl font-extrabold text-white">
                  Access to Personal Information and Other Questions
                </h2>
                <p className="text-base font-medium text-white">
                  Under applicable regulations in the UK and the US, you have
                  the right to obtain confirmation from [AI] Analytics
                  Intelligence relating to the processing of your personal data,
                  including the right to request a copy of all data processed
                  about yourself. You also have the right to contact us to
                  request information about the Personal Information we have
                  collected from you in order to request the correction,
                  modification, or deletion of such information. To make such a
                  request and/or to pose any other questions regarding this
                  Policy, please contact us via email at{" "}
                  <a
                    href="mailto:privacy@analyticsintelligence.com"
                    className="text-[#88BEFF]"
                  >
                    privacy@analyticsintelligence.com
                  </a>
                </p>
              </section>

              <section
                id="compliance"
                className=" flex flex-col gap-8 scroll-mt-28"
              >
                <h2 className="text-2xl font-extrabold text-white">
                  Compliance with Cyber Security and Data Privacy Regulations
                </h2>
                <div className="space-y-4">
                  <p className="text-base font-extrabold text-white">
                    Cyber Security Regulations (UK and US)
                  </p>
                  <div className="space-y-1">
                    <p className="text-base font-medium text-white">
                      <span className="font-extrabold">
                        National Cyber Strategy (UK):
                      </span>
                      We are committed to making our AI systems secure by
                      design, ensuring robust security is built into our systems
                      from the development stage.
                    </p>
                    <p className="text-base font-medium text-white">
                      <span className="font-extrabold">
                        AI Cyber Security Code of Practice (UK):
                      </span>
                      We adhere to the voluntary code developed by the
                      Department for Science, Innovation and Technology (DSIT),
                      based on guidelines from the National Cyber Security
                      Centre (NCSC), to protect end-users and ensure security
                      throughout the lifecycle of our AI models and systems.
                    </p>
                    <p className="text-base font-medium text-white">
                      <span className="font-extrabold">
                        Cyber Governance Code of Practice (UK):
                      </span>
                      We ensure compliance with baseline expectations for cyber
                      security standards as outlined in this code, relevant to
                      the use of our generative AI tools.
                    </p>
                    <p className="text-base font-medium text-white">
                      <span className="font-extrabold">
                        Federal Trade Commission (FTC) Guidelines (US):
                      </span>
                      We ensure our AI systems comply with FTC guidelines,
                      avoiding deceptive practices and adhering to consumer
                      protection laws. National Institute of Standards and
                      Technology (NIST) Framework (US): We follow NIST
                      guidelines and standards to enhance the security and
                      resilience of our AI systems
                    </p>
                  </div>
                </div>

                <div className="space-y-4">
                  <p className="text-base font-extrabold text-white">
                    Data Privacy Regulations (UK and US)
                  </p>
                  <div className="space-y-1">
                    <p className="text-base font-medium text-white">
                      <span className="font-extrabold">
                        UK General Data Protection Regulation (UK GDPR):
                      </span>
                      We process personal data in accordance with the principles
                      of lawfulness, fairness, transparency, purpose limitation,
                      data minimization, accuracy, storage limitation, and
                      integrity and confidentiality.
                    </p>
                    <p className="text-base font-medium text-white">
                      <span className="font-extrabold">
                        Data Protection Act 2018 (DPA 2018) (UK):
                      </span>
                      We comply with the comprehensive framework for data
                      protection in the UK, including specific provisions for
                      law enforcement and intelligence services.
                    </p>
                    <p className="text-base font-medium text-white">
                      <span className="font-extrabold">
                        ICO Consultation Series on Generative AI (UK):
                      </span>
                      We stay informed and compliant with the guidance provided
                      by the Information Commissioner's Office (ICO) regarding
                      data protection laws as they apply to generative AI,
                      including issues such as the lawful basis for training AI
                      models, purpose limitation, accuracy, and data subject
                      rights.
                    </p>
                    <p className="text-base font-medium text-white">
                      <span className="font-extrabold">
                        California Consumer Privacy Act (CCPA) (US):
                      </span>
                      We comply with the CCPA, ensuring California residents can
                      exercise their rights over personal data, including
                      knowing what data is collected, requesting deletion, and
                      opting out of data sales.
                    </p>
                    <p className="text-base font-medium text-white">
                      <span className="font-extrabold">
                        Virginia Consumer Data Protection Act (VCDPA) (US):
                      </span>
                      We adhere to the VCDPA, providing Virginia residents with
                      rights over their personal data and fulfilling our
                      obligations to protect that data.
                    </p>
                    <p className="text-base font-medium text-white">
                      <span className="font-extrabold">
                        Colorado Privacy Act (CPA) (US):
                      </span>
                      We follow the CPA, ensuring Colorado residents' data
                      rights are respected and implementing necessary data
                      protection measures
                    </p>
                  </div>
                </div>

                <div className="space-y-4">
                  <p className="text-base font-extrabold text-white">
                    Federal and State AI-Specific Regulations (US)
                  </p>
                  <div className="space-y-1">
                    <p className="text-base font-medium text-white">
                      <span className="font-extrabold">
                        White House Executive Order on AI (US):
                      </span>
                      We adhere to the principles outlined in this order,
                      ensuring the responsible development and use of AI,
                      including privacy, security, and fairness.
                    </p>
                    <p className="text-base font-medium text-white">
                      <span className="font-extrabold">
                        Federal Legislation Proposals (US):
                      </span>
                      We stay informed and compliant with proposed federal laws,
                      including those requiring AI system licensing and the
                      establishment of a federal regulatory agency for AI.
                    </p>
                    <p className="text-base font-medium text-white">
                      <span className="font-extrabold">
                        State Legislation (US):
                      </span>
                      We comply with various state regulations and executive
                      orders, such as California's Executive Order on Generative
                      AI, ensuring safety and privacy measures for AI systems
                      used by the state.
                    </p>
                  </div>
                </div>

                <div className="space-y-4">
                  <p className="text-base font-extrabold text-white">
                    Additional Considerations (UK and US)
                  </p>
                  <div className="space-y-1">
                    <p className="text-base font-medium text-white">
                      <span className="font-extrabold">
                        Intellectual Property Laws:
                      </span>
                      We comply with intellectual property laws, recognizing
                      that human authorship is essential for valid copyright
                      claims, and ensuring the appropriate use of data for
                      training AI models and the treatment of AI-generated
                      content.
                    </p>
                    <p className="text-base font-medium text-white">
                      <span className="font-extrabold">
                        Ethical and Bias Considerations:
                      </span>
                      We conduct bias assessments and ensure transparency in AI
                      decision-making processes to avoid perpetuating biases and
                      promote ethical AI use.
                    </p>
                    <p className="text-base font-medium text-white">
                      <span className="font-extrabold">
                        Confidentiality Obligations:
                      </span>
                      We ensure that using generative AI tools does not breach
                      confidentiality obligations, controlling and overseeing
                      data use, and preventing inappropriate data sharing.
                    </p>
                  </div>
                </div>
              </section>
            </main>
          </div>
        </section>
        <NewFooter />
      </main>
    </>
  );
}
